/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import {
  Title,
  Button,
  ExpandablePanel,
  TableFooter,
  CategoryModal,
  OptionList,
  EmptyView,
  SearchBar, Modal
} from '../../components';
import { styles } from './Categories.styles';
import { checkAccess } from '../../utils/admins';
import * as actions from '../../actions/index';
import {
  handleRemoveCategorie,
  handleModifyCategorie,
  closeModal,
  handleChangeExpend,
  handleDuplicateCategorie,
  deleteCategorie,
  handleSearchChange,
  getCategories,
  groupDependencies
} from './Categories.services';
import { mainColor, PRODUCT, SPLASH, UNIT } from '../../constants';
import { isObjectNotEmpty, isStringNotNull } from '../../utils/tools';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/box.svg';
import { EMPTY_DESIGN_OPTIONS_TEXT, EMPTY_DESIGN_OPTIONS_TITLE } from '../../constants/dishopInfo';
import ShopModal from '../../components/ShopModal';
import { handleSynchronisationToggle, debouncedUpdate } from '../../utils/shopUtils';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import store from '../../utils/store';
import { listenMenusPOSRealTime } from '../../apis/firebase';
const INITIAL_STATE = {
  isLoading: false,
  synchronize: false,
  createCategorie: false,
  items: {},
  category: {
    name: '',
    description: ''
  },
  item: '',
  showAddCategoryModal: false,
  showModal: false,
  searchTerm: '',
  allCategories: {},
  showInfoModal: false,
  categoryKey: ''
};
class Categories extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }
  async componentDidMount() {
    await debouncedUpdate(this.props.menu);
    await listenMenusPOSRealTime(store.dispatch, this.props.shopId);
  }
  async componentWillReceiveProps(nextProps) {
    const { menu, shopId } = nextProps;
    const { menu: oldMenu, shopId: oldShopId } = this.props;
    if (!_.isEqual(oldMenu?.categories, menu?.categories)) {
      await debouncedUpdate(menu);
    }
    if (!_.isEqual(oldShopId, shopId)) {
      await listenMenusPOSRealTime(store.dispatch, shopId);
      this.setState({ searchTerm: '' })
    }
  }
  renderOptionList = (categoryKey, items) => {
    return <OptionList key={categoryKey} options={items} categoryKey={categoryKey} />;
  };

  createTableRow = () => {
    const { expanded } = this.state;
    const { page } = this.props;
    const { numPage, rowsPerPage } = page;
    const categories = getCategories(this);
    const renderCategories =
      categories &&
      _.keys(categories)
        .sort((a, b) => categories[a]?.name?.localeCompare(categories[b].name))
        .slice(numPage * rowsPerPage, numPage * rowsPerPage + rowsPerPage);
    return renderCategories.map((categoryKey, index) => {
      const { max = '', items = {}, multiple = false, min = '' } = categories[categoryKey];
      const choiceType = (
        <>
          {multiple ? 'Choix multiple' : 'Choix unique'}
          <p style={{ color: mainColor.colorBlack }}>
            {min >= 1 ? `Obligatoire` : `Optionnel`}
            {!max ? (min <= 1 ? ' sans limite' : ` avec minimum ${min} items`) : ''}
            {max > 1 ? (min > 0 ? ` entre ${min} et ${max} items` : ` avec ${max} items max`) : ''}
          </p>
        </>
      );
      return (
        <ExpandablePanel
          expanded={expanded === index}
          onExpand={(e, expanded) => handleChangeExpend(e, expanded, index, this)}
          onRemove={() => { handleRemoveCategorie(categoryKey, this); this.setState({ showModal: false, synchronize: false }) }}
          onUpdate={() => handleModifyCategorie(categoryKey, this)}
          onDuplicate={() => handleDuplicateCategorie(categories[categoryKey], this)}
          renderItems={() => this.renderOptionList(categoryKey, items)}
          item={{ ...categories[categoryKey], description: choiceType }}
          hasInfoIcon={true}
          onOpen={() => this.setState({ showInfoModal: true, categoryKey })}
        />
      );
    });
  };

  renderCreateCategoryButton = () => {
    return (
      <Button
        className='btn-xs-block'
        color='primary'
        disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('category', 'hideCreateCategory')}
        onClick={() =>
          this.setState({
            createCategorie: true,
            category: hasExternalIntegration(this.props.shopId) === SPLASH ? { type: PRODUCT } : {},
            showAddCategoryModal: true
          })
        }
      >
        <div className='row justify-content-center align-items-center mr-0 ml-0'>
          <AddIcon />
          <p className='m-0 ml-1'> Créer une nouvelle liste d'options</p>
        </div>
      </Button>
    );
  };
  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoading } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoading}
        onClick={() => deleteCategorie(this)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={'Sélectionnez les magasins dont vous voulez supprimer cette liste d`option:'}
        title={'Supprimer cette liste d`option:'}
        isSuppression={true}
      />
    );
  };
  getDependencies = (dependencies, type) => {
    const { classes } = this.props;

    return (
      <>
        <h4 className='py-2 font-weight-bold'>{type}</h4>
        <div className={classes.dependencies}>
          {dependencies.map((group, index) => (
            <div key={`group-${index}`}>
              <h5>
                <span className={classes.groupTitle}>"{group.parentName}"</span>
                <span className={classes.itemKey}>{" "} {group.parentKey}</span>
              </h5>
              <div>
                {group.items.map((item, itemIndex) => (
                  <h6 key={`item-${itemIndex}`} className={classes.item}>
                    <span className={classes.itemName}>{item.name}</span>
                    <span className={classes.itemKey}>{" "} {item.key}</span>
                  </h6>
                ))}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  renderInfoModal = () => {
    const { categoryKey, showInfoModal } = this.state;
    const { categories, sections, classes } = this.props;

    const productDependencies = groupDependencies(
      (section) => section.products,
      sections,
      categoryKey
    );
    const optionDependencies = groupDependencies(
      (category) => category.items,
      categories,
      categoryKey
    );

    const hasManyDependencies =
      productDependencies.some(dep => dep.items.length > 7) ||
      optionDependencies.some(dep => dep.items.length > 7) ||
      productDependencies.length > 10 ||
      optionDependencies.length > 10;

    return (
      <Modal
        isOpen={showInfoModal}
        handleClose={() => this.setState({ showInfoModal: false })}
        color="secondary"
        title="Liste des dépendances"
        subTitle="Ensemble des produits et options qui font appel à cette liste d'options lorsqu'on les sélectionne."
        header
        width="580px"
        size="md"
        modalBodyClass="py-0"
        btnTxt="Fermer"
        onClick={() => this.setState({ showInfoModal: false })}
      >
        {productDependencies.length === 0 && optionDependencies.length === 0 ? (
          <p className="text-center p-5">
            Aucun élément de la carte n'appelle cette liste d’options.
          </p>
        ) : (
          <div
            className={classes.modalBody}
            style={{
              height: hasManyDependencies && `${UNIT * 18.75}px`,
            }}
          >
            <>
              {productDependencies.length > 0 &&
                this.getDependencies(productDependencies, 'Par sections')}
              {optionDependencies.length > 0 &&
                this.getDependencies(optionDependencies, "Par listes d'options")}
            </>
          </div>
        )}
      </Modal>
    );
  };



  render() {
    const { categories = {}, showHelpModal, classes, shopId } = this.props;
    const { showAddCategoryModal, category, items, showModal } = this.state;
    return (
      <div className='px-4 pb-4 noselect'>
        <Title title={`Liste d'options`} onClick={() => showHelpModal('options')} />
        {isObjectNotEmpty(categories) ? (
          <>
            <div className='row'>
              <div className="col mt-3 mt-sm-0 d-flex  align-self-center">
                <SearchBar
                  value={this.state.searchTerm}
                  label={'Chercher une option'}
                  onChange={e => handleSearchChange(e, this)}
                  onBlur={() => getCategories(this)}
                  onClick={() => getCategories(this)}
                />
              </div>
              <div className="col mt-3 mt-sm-0 d-flex flex-row-reverse align-self-center">
                {this.renderCreateCategoryButton()}
              </div>
            </div>
            {this.createTableRow()}
            <TableFooter
              rowsPerPageOptions={[10, 20, 50]}
              lengthOption={_.keys(getCategories(this)).length}
              isSearch={isStringNotNull(this.state.searchTerm)}
            />
          </>
        ) : (
          <EmptyView
            className={classes.svg}
            src={ImportedSVG}
            viewBox='0 0 256 256'
            title={EMPTY_DESIGN_OPTIONS_TITLE}
            text={EMPTY_DESIGN_OPTIONS_TEXT}
          >
            {this.renderCreateCategoryButton()}
          </EmptyView>
        )}
        {showAddCategoryModal && (
          <CategoryModal
            createCategorie={this.state.createCategorie}
            isOpen={showAddCategoryModal}
            category={category}
            items={items}
            closeModal={() => closeModal(this)}
          />
        )}
        {showModal && this.renderShops(classes, shopId)}
        {this.state.showInfoModal && this.renderInfoModal()}
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, page, user }) {
  const { shops = {}, menu = {} } = firebaseRealTime;
  const { shopId, nbShops } = user;
  const { categories = {}, sections } = menu;
  return {
    categories,
    page,
    shopId,
    nbShops,
    shops,
    menu,
    sections
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(Categories));
